var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestingIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.601,
    height: 48,
    viewBox: "0 0 33.601 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24211",
    "data-name": "Path 24211",
    d: "M186.73,2.188h-28.8a2.4,2.4,0,0,0-2.4,2.4v43.2a2.4,2.4,0,0,0,2.4,2.4h28.8a2.4,2.4,0,0,0,2.4-2.4V4.587a2.4,2.4,0,0,0-2.4-2.4Zm-14.4,45.6a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,172.329,47.787Zm12-8.164a.962.962,0,0,1-.964.964H161.293a.962.962,0,0,1-.964-.964V7.942a.962.962,0,0,1,.964-.964h22.082a.962.962,0,0,1,.964.964V39.624Z",
    transform: "translate(-155.529 -2.188)",
    fill: "#86bc26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingIcon1);
export default __webpack_public_path__ + "static/media/testing-icon-1.efb63054b3d7b7430827339c61750db5.svg";
export { ForwardRef as ReactComponent };